// extracted by mini-css-extract-plugin
module.exports =  {"adminBoardSettingsGeneral":"ZxLXM3sp","namingFields":"FZpT9rHe","description":"Tr2Xjz_B","row":"fUBb22K1","dependent":"s_BU84uz","error":"d5L9vgXN","button":"tJbbxFeP"};